import { render } from "./CourseLayout.vue?vue&type=template&id=5d9c0f94"
import script from "./CourseLayout.vue?vue&type=script&lang=js"
export * from "./CourseLayout.vue?vue&type=script&lang=js"

import "./CourseLayout.vue?vue&type=style&index=0&id=5d9c0f94&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__